import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { modalAnimations } from '@df/ui/modal/modal-animations';
import { ModalContainerAbstract } from '@df/ui/modal/modal-container.abstract';

/**
 * Internal component that wraps user-provided top modal content.
 */
@Component({
    selector: 'modal-custom-container',
    template: `<ng-template cdkPortalOutlet />`,
    styleUrl: './modal-container.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [modalAnimations.modalCustomContainer],
    host: {
        class: 'modal-container modal-custom-container',
        tabindex: '-1',
        'aria-modal': 'true',
        '[attr.id]': 'id',
        '[attr.role]': 'config.role',
        '[attr.aria-labelledby]': 'config.ariaLabel ? null : ariaLabelledBy',
        '[attr.aria-label]': 'config.ariaLabel',
        '[attr.aria-describedby]': 'config.ariaDescribedBy || null',
        '(@modalCustomContainer.start)': 'onAnimationStart($event)',
        '(@modalCustomContainer.done)': 'onAnimationDone($event)'
    },
    standalone: true,
    imports: [CdkPortalOutlet]
})
export class ModalCustomContainerComponent extends ModalContainerAbstract {
    @HostBinding('@modalCustomContainer') get getModalContainer() {
        return {
            value: this.animationState,
            params: {
                transform: this.config.transformOptions,
                transition: this.config.transitionOptions
            }
        };
    }
}
